module.exports = "<main class=\"popups success\" align=\"center\">\n  <h2 class=\"capitalize\">Request sent successfully</h2>\n    Your requested operation was successful!\n    <br><br>\n    <button type=\"button\" class=\"btn btn-sm btn-popups capitalize\" style=\"width:150px\" (click)=\"closeModal()\">close</button>\n  </main>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/achelos-iot/modals/success-modal/success-modal.component.html
// module id = ./src/app/achelos-iot/modals/success-modal/success-modal.component.html
// module chunks = main